<template>
	<div id="app">
		<router-view />
	</div>
</template>

<script>
export default {
	name: 'App',
	watch: {
		//可视化首次展示
		$route(to, from) {
			if (to.path === '/pharma/chemicalMajor' && from.path === '/index') {
				sessionStorage.setItem('nowIndex', JSON.stringify(0));
			} else {
				sessionStorage.setItem('nowIndex', JSON.stringify(1));
			}
		},
	},
};
</script>

<style>
html,
body,
#app {
	/* width: 100%; */
	overflow-y: auto;
	height: 100vh;
	/* height: 100%; */
	margin: 0;
	padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/App.vue